// extracted by mini-css-extract-plugin
module.exports = {"nav":"BackNavBar_nav__PGLwj"};